exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".content__rIk0b:after{content:\"\";display:inline;margin-right:78px}.contentFaded__3CYP0{color:#9e9e9e;font-style:italic}.attachment__IxcRs{padding:2px}", "", {"version":3,"sources":["/opt/build/repo/src/components/MessageBubbleContent/MessageBubbleContent.styles.scss"],"names":[],"mappings":"AAEA,sBAEI,WACA,eACA,iBAAkB,CACnB,qBAID,cACA,iBAAkB,CACnB,mBAGC,WAAY,CACb","file":"MessageBubbleContent.styles.scss","sourcesContent":["@import '../../variables';\n\n.content {\n  &:after {\n    content: '';\n    display: inline;\n    margin-right: 78px;\n  }\n}\n\n.contentFaded {\n  color: $gray-500;\n  font-style: italic;\n}\n\n.attachment {\n  padding: 2px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"content": "content__rIk0b",
	"contentFaded": "contentFaded__3CYP0",
	"attachment": "attachment__IxcRs"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/MessageBubbleContent/MessageBubbleContent.styles.scss
// module id = /GMg
// module chunks = 0